<template>
    <div v-if="pages > 1" class="row no-margins">
        <div class="col-md-12 text-center">
            <ul class="pagination">
                <li class="footable-page-arrow">
                    <a href="#" @click.stop.prevent="first" aria-label="first page">
                        <i class="fa-regular fa-backward-fast"></i>
                    </a>
                </li>
                <li class="footable-page-arrow">
                    <a href="#" @click.stop.prevent="prev" aria-label="previous page">
                        <i class="fa-regular fa-backward"></i>
                    </a>
                </li>
                <li class="footable-page">
                    <a href="#" aria-label="footable page">
                        {{ pageof }}
                    </a>
                </li>
                <li class="footable-page-arrow">
                    <a href="#" @click.stop.prevent="next" aria-label="next page">
                        <i class="fa-regular fa-forward"></i>
                    </a>
                </li>
                <li class="footable-page-arrow">
                    <a href="#" @click.stop.prevent="last" aria-label="last page">
                        <i class="fa-regular fa-forward-fast"></i>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    export default {
        props: [
            'page',
            'pages',
            'event'
        ],
        computed: {
            pageof: function () {
                return Lang.langGet("Page :page of :maxpage", {page: this.page + 1, maxpage: this.pages})
            }
        },
        methods: {
            first: function () {
                EaseEventBus.fire(this.event, 0);
            },
            last: function () {
                EaseEventBus.fire(this.event, this.pages - 1);
            },
            prev: function () {
                if (this.page <= 1) {
                    this.first();
                } else {
                    EaseEventBus.fire(this.event, this.page - 1);
                }
            },
            next: function () {
                if (this.page === this.pages - 1) {
                    this.last();
                } else {
                    EaseEventBus.fire(this.event, this.page + 1);
                }
            }
        }
    }
</script>
